/**
 *
 */

import { Injectable } from '@angular/core';

import { CommonRequestService } from './common-request.service';
import { CommonRequestTableService } from './common-table-request.service';
import { CommonGfoService } from './common-gfo.service';
import { UserService } from './user.service';
import { AdminService } from './admin.service';
import { AppSettings } from '../app.settings';

export interface SubsUser {
	userEmail: string;
	userName: string;
	userId: number;
	signupState: any; // TODO: ACTIVATE
	userSubs: {
		[appName: string]: boolean;
	};
	userSubsDetails?: object;
	isAdmin?: boolean; // Is user a customer admin
}

@Injectable()
export class UserManagementService {

	public users: SubsUser[];
	constructor(
		private requestService: CommonRequestService,
		private requestTableService: CommonRequestTableService,
		private gfoService: CommonGfoService,
		private userService: UserService,
		private adminService: AdminService
	) {}

	// getUsersFromUserSubs(userSubs: UserSubscription[]) {
	// 	const usersById = {};
	// 	const users: SubsUser[] = [];
	// 	userSubs.forEach((item) => {
	// 		if (!usersById[item.userId]) {
	// 			usersById[item.userId] = {
	// 				userEmail: item.userEmail,
	// 				userId: item.userId,
	// 				userSubs: {}, // for display use in html
	// 				userSubsDetails: {}
	// 			};
	// 		}
	// 		usersById[item.userId].userSubsDetails[item.appName] = {
	// 			module: item.appName,
	// 			role: item.role,
	// 			subId: item.subId,
	// 			userSubId: item.userSubId
	// 		};
	// 		usersById[item.userId].userSubs[item.appName] = true;
	// 	});
	// 	for (const id of Object.keys(usersById)) {
	// 		users.push(usersById[id]);
	// 	}
	// 	return users;
	// }

	// TODO: Remove
		// getUsersByAdmin(successCallback?, errorCallback?) {
		// 	const table = 'userSubView'; // to match the table in gfoService's tables
		// 	const returnCols = this.gfoService.getReturnColumnsByNames(['userEmail', 'subExpire', 'role'], table);
		// 	const filter = this.gfoService.getFilter(
		// 		'cus_id',
		// 		null, // 'number'
		// 		this.gfoService.filterOperators.equal,
		// 		this.userService.getUserInfo().customerId
		// 	);
		// 	const gfo = this.gfoService.getGfo(
		// 		this.gfoService.filterLogics.and,
		// 		this.gfoService.tables[table].name,
		// 		returnCols,
		// 		[filter]
		// 	);
		// 	this.requestTableService.tableGet(gfo, null, (rsp) => {
		// 		this.users = this.transformUsers(rsp.data);
		// 		if (successCallback) {
		// 			successCallback(this.users);
		// 		}
		// 	}, errorCallback);
		// }
		// transformUsers(data: any[]): SubsUser[] {
		// 	const usersById = {};
		// 	const users: SubsUser[] = [];
		// 	data.forEach((item) => {
		// 		if (!usersById[item.usr_id]) {
		// 			usersById[item.usr_id] = {
		// 				cusId: item.cus_id,
		// 				userEmail: item.usr_email,
		// 				userId: item.usr_id,
		// 				subs: {}, // for display use in html
		// 				subDetails: {}
		// 			};
		// 		}
		// 		usersById[item.usr_id].subs[item.sub_mod_cd] = {
		// 			module: item.sub_mod_cd,
		// 			expire: item.sub_expire,
		// 			role: item.rol_cgs_role
		// 		};
		// 	});
		// 	for (const id of Object.keys(usersById)) {
		// 		users.push(usersById[id]);
		// 	}
		// 	return users;
		// }
}



// WEBPACK FOOTER //
// ./src/app/common-services/user-management.service.ts